import React, { useState, useEffect } from 'react'
import { Table, IconButton, Icon, Panel, ButtonGroup, Row, Col, Dropdown, Button } from 'rsuite'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import pathname from '../../constants/pathname'
import { useHistory } from 'react-router-dom'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import TooltipButton from '../../components/buttons/TooltipButton'
import EditButton from '../../components/buttons/editButton/EditButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import DownloadButton from '../../components/buttons/downloadButton/downloadButton'

export default function TableLealManagement({
  schema,
  dataKeyTable,
  pagination,
  onReload,
  loading,
  hiddenColStatus,
  onSearchCommittee,
  onEdit,
  onDownload = () => {},
  onDelete = () => {},
  onExport = () => {},
  expand: _expand,
  onSelect,
  hideColumn,
  widgetFrom,
  isTrackingHistoryLaw = false,
  pageSize,
  pageNumber,
  enableEdit,
  ...props
}) {
  // const { pagesize, pagenumber } = props

  const { Column, HeaderCell, Cell } = Table
  const [displayLength, setDisplayLength] = useState(pageSize || 5)
  const [page, setPage] = useState(pageNumber || 1)
  const [tableData, setTableData] = useState([])
  const history = useHistory()
  const styleHeaderCell = { whiteSpace: 'normal', wordBreak: 'break-word' }
  const fs = localStorage.getItem('fontSize')

  const defaultPage = 1
  const defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ]

  useEffect(() => {
    if (pagination && typeof onReload !== 'function') {
      setTableData(getData())
    } else if (schema.values) {
      setTableData(schema.values)
    } else {
      setTableData([])
    }
  }, [schema, pagination, onReload])

  useEffect(() => {
    console.log('pagenumber : ', pageNumber, 'pagesize : ', pageSize)
    setPage(pageNumber)
    setDisplayLength(pageSize)
  }, [pageSize, pageNumber])

  const getData = () => {
    return schema?.values?.filter((v, i) => {
      const start = displayLength * (page - 1)
      const end = start + displayLength
      return i >= start && i < end
    })
  }

  const handleChangePage = (dataKey) => {
    console.log('handleChangePage page', dataKey)

    setPage(dataKey)
    if (typeof onReload === 'function') {
      onReload(displayLength, dataKey)
    }
  }

  const handleChangeLength = (dataKey) => {
    console.log('handleChangeLength dataKey', dataKey)
    setPage(1)
    setDisplayLength(dataKey)
    if (typeof onReload === 'function') {
      onReload(dataKey, 1)
    }
  }

  return (
    <>
      <Panel
        header={schema.header || 'แสดงรายการงานคดี'}
        shaded
        collapsible
        defaultExpanded
        bordered
      >
        {schema.exportButton && (
          <Row>
            <Col xs={24} sm={24} md={24} lg={24} style={{ textAlign: 'right' }}>
              {enableEdit && (
                <SaveButton
                  icon="plus"
                  onClick={() => {
                    sessionStorage.setItem('projectId', 'menu')
                    sessionStorage.setItem('param', '')

                    history.push({
                      pathname: `${pathname.law.SaveLawList}`,
                    })
                  }}
                  style={{
                    marginRight: 10,
                  }}
                >
                  บันทึกคดีใหม่
                </SaveButton>
              )}
              <IconButton
                icon={<Icon icon="file-excel-o" className="bt-gost-icon-radius" />}
                style={{
                  marginRight: 10,
                }}
                appearance="primary"
                onClick={onExport}
              >
                {schema.exportButton.label}
              </IconButton>{' '}
            </Col>
          </Row>
        )}

        <Table
          wordWrap
          minHeight={350}
          autoHeight
          loading={loading}
          data={tableData}
          style={{ marginTop: '20px' }}
          headerHeight={fs <= 17 ? undefined : 50}
        >
          <Column width={70} align="center">
            <HeaderCell style={styleHeaderCell}>ลำดับ</HeaderCell>
            <Cell>
              {(_, index) => {
                return index + 1
              }}
            </Cell>
          </Column>

          <Column width={130}>
            <HeaderCell style={styleHeaderCell}>เลขที่สัญญา</HeaderCell>
            <Cell dataKey="referCodeDocument" />
          </Column>

          <Column width={300}>
            <HeaderCell style={styleHeaderCell}>ชื่อคดี</HeaderCell>
            <Cell dataKey="litigationName" />
          </Column>

          <Column width={150}>
            <HeaderCell style={styleHeaderCell}>รหัสโครงการ</HeaderCell>
            <Cell dataKey="projectCode" />
          </Column>

          <Column width={250}>
            <HeaderCell style={styleHeaderCell}>ชื่อโครงการ</HeaderCell>
            <Cell dataKey="projectName" />
          </Column>

          <Column width={180}>
            <HeaderCell style={styleHeaderCell}>สำนัก</HeaderCell>
            <Cell dataKey="department" />
          </Column>

          <Column width={150}>
            <HeaderCell style={styleHeaderCell}>ผู้ประสาน</HeaderCell>
            <Cell dataKey="staffName" />
          </Column>

          <Column width={130}>
            <HeaderCell style={styleHeaderCell}>วันที่อนุมัติ</HeaderCell>
            <Cell dataKey="approveDate" />
          </Column>

          <Column width={180}>
            <HeaderCell style={styleHeaderCell}>วันที่เริ่มต้นโครงการ</HeaderCell>
            <Cell dataKey="projectStartDate" />
          </Column>

          <Column width={180}>
            <HeaderCell style={styleHeaderCell}>วันที่สิ้นสุดโครงการ</HeaderCell>
            <Cell dataKey="projectEndDate" />
          </Column>

          <Column width={120}>
            <HeaderCell style={styleHeaderCell}>ผู้ดูแล</HeaderCell>
            <Cell dataKey="caretaker" />
          </Column>

          <Column width={180}>
            <HeaderCell style={styleHeaderCell}>สถานะโครงการ/PO</HeaderCell>
            <Cell dataKey="projectPOStatus" />
          </Column>
          <Column width={220}>
            <HeaderCell style={styleHeaderCell}>ประเภทคดี</HeaderCell>
            <Cell dataKey="lawType" />
          </Column>
          <Column width={220}>
            <HeaderCell style={styleHeaderCell}>สถานะทางกฎหมาย</HeaderCell>
            <Cell dataKey="lawStatus" />
          </Column>

          <Column width={230}>
            <HeaderCell style={styleHeaderCell}>สถานะย่อยทางกฎหมาย</HeaderCell>
            <Cell dataKey="lawSubStatus" />
          </Column>

          {/* <Column width={200}>
            <HeaderCell>ประเภทการออกหนังสือ</HeaderCell>
            <Cell dataKey="documentStatus" />
          </Column> */}

          <Column width={180}>
            <HeaderCell style={styleHeaderCell}>ทุนทรัพย์</HeaderCell>
            <Cell dataKey="capital" />
          </Column>

          <Column width={210} align="center">
            <HeaderCell style={styleHeaderCell}>วันที่ดำนเนินการล่าสุด</HeaderCell>
            <Cell>
              {(item, _) => {
                return item?.actionDate?.date || ''
              }}
            </Cell>
          </Column>

          <Column width={210} align="center">
            <HeaderCell style={styleHeaderCell}>ครบกำหนดอายุความ</HeaderCell>
            <Cell>
              {(item, _) => {
                return item?.actionDate?.due || ''
              }}
            </Cell>
          </Column>

          {enableEdit && (
            <Column width={130} align="center">
              <HeaderCell style={styleHeaderCell}>การติดตาม</HeaderCell>
              <Cell>
                {(rowData) => {
                  return (
                    <>
                      <IconButton
                        disabled={rowData.isDisabled}
                        color="blue"
                        appearance="primary"
                        icon={<Icon icon="save" />}
                        onClick={() => {
                          sessionStorage.setItem('projectId', 'menu')
                          sessionStorage.setItem('param', `?${rowData.id}`)

                          history.push({
                            pathname: `${pathname.law.SaveLawTracking}`,
                          })
                        }}
                        size="sm"
                      >
                        ติดตามคดี
                      </IconButton>
                    </>
                  )
                }}
              </Cell>
            </Column>
          )}

          {/* <Column width={220} align="center">
            <HeaderCell style={styleHeaderCell}>หนังสือถวงถาม Notice</HeaderCell>
            <Cell>
              {(rowData) => {
                return (
                  <>
                    <IconButton
                      disabled={rowData.isDisabled}
                      color="green"
                      appearance="primary"
                      icon={<Icon icon="file-text-o" />}
                      onClick={() => {
                        history.push({
                          pathname: `${pathname.law.CallBookNotice}/${rowData.id}`,
                        })
                      }}
                      size="sm"
                    >
                      หนังสือถวงถาม Notice
                    </IconButton>
                  </>
                )
              }}
            </Cell>
          </Column> */}

          <Column width={enableEdit ? 315 : 150} align="center">
            <HeaderCell style={styleHeaderCell}>หนังสือบอกเลิก</HeaderCell>
            <Cell>
              {(rowData) => {
                return (
                  <>
                    {enableEdit && (
                      <IconButton
                        color="orange"
                        disabled={rowData.isDisabled || !rowData.enbleTerminate}
                        appearance="primary"
                        icon={<Icon icon="file-text-o" />}
                        onClick={() => {
                          sessionStorage.setItem('projectId', rowData.id)
                          sessionStorage.setItem('param', '')
                          history.push({
                            pathname: `${pathname.law.DocumentOfTermination}`,
                          })
                        }}
                        size="sm"
                      >
                        หนังสือบอกเลิก
                      </IconButton>
                    )}

                    <DownloadButton
                      size="sm"
                      disabled={
                        rowData.pathFile == undefined ||
                        rowData.pathFile == null ||
                        rowData.pathFile == ''
                      }
                      style={{ marginLeft: 10 }}
                      onClick={() => {
                        onDownload(rowData.litigationCode, rowData.eContractId, rowData.pathFile)
                      }}
                    />
                  </>
                )
              }}
            </Cell>
          </Column>
          <Column width={100} align="center" fixed="right">
            <HeaderCell style={styleHeaderCell}>จัดการ</HeaderCell>
            <Cell>
              {(rowData) => {
                return (
                  <>
                    {enableEdit ? (
                      <>
                        <EditButton
                          size="sm"
                          onClick={(e) => {
                            sessionStorage.setItem('projectId', 'menu')
                            sessionStorage.setItem('param', `?${rowData.id}`)
                            history.push({
                              pathname: `${pathname.law.SaveLawList}`,
                            })
                          }}
                        />
                        {/* <CancelButton
                      size="sm"
                      icon="trash-o"
                      children="ลบ"
                      onClick={() => {
                        onDelete(rowData.id)
                      }}
                    /> */}
                      </>
                    ) : (
                      <SaveButton
                        size="sm"
                        icon="eye"
                        onClick={(e) => {
                          sessionStorage.setItem('projectId', 'menu')
                          sessionStorage.setItem('param', `?${rowData.id}`)
                          history.push({
                            pathname: `${pathname.law.SaveLawList}`,
                          })
                        }}
                      >
                        แสดง
                      </SaveButton>
                    )}
                  </>
                )
              }}
            </Cell>
          </Column>
        </Table>

        {pagination && (
          <TablePagination
            lengthMenu={defaultLengthMenu}
            activePage={page || defaultPage}
            renderLengthMenu={(lengthMenu) => {
              return (
                <>
                  {lengthMenu}
                  {`รายการ/หน้า`}
                </>
              )
            }}
            renderTotal={(total) => {
              return <>{` ทั้งหมด ${total} รายการ`}</>
            }}
            displayLength={displayLength || 5}
            total={schema?.totalSize || 0}
            onChangePage={handleChangePage}
            onChangeLength={handleChangeLength}
          />
        )}
      </Panel>
    </>
  )
}
